import React, {useContext, useEffect, useRef, useState} from 'react';
import './Birthday.less';
import {DrawerPopup} from "dialog-layout/drawer-popup/DrawerPopup.tsx";
import {Button} from "elements/button/Button";
import {SelectList} from "compositions/select-list/SelectList";
import ScrollHelper from "helpers/scroll.helper";
import {Error} from "elements/error/Error";
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation} from "helpers/localization.helper.ts";
import {getMonthTranslationKey} from "helpers/order-time.helper";
import {Checkbox} from "elements/checkbox/Checkbox.tsx";
import {SelectListItem} from "compositions/select-list-item/SelectListItem.tsx";

function getYears() {
	const currentYear = new Date().getFullYear();

	let years = [];

	for (let i = currentYear - 100; i < currentYear - 10; i += 1) {
		years.push(new Date(i, 1, 1));
	}

	return years.reverse();
}

function getMonths() {
	let months = [];

	for (let i = 0; i < 12; i += 1) {
		months.push(new Date(2000, i, 1));
	}

	return months;
}

function getMonthDates(year, month) {
	let dates = [];

	for (var i = 1; i < 32; i += 1) {
		const currentDate = new Date(year, month, i);

		if (currentDate.getMonth() === month) {
			dates.push(currentDate);
		}
	}

	return dates;
}

export const BIRTHDAY_POPUP = 'BIRTHDAY_POPUP';

export const Birthday = ({defaultValue = '', error, onDoneClick, onCancelClick, onOverlayClick}) => {
	//TODO extract date picker

	const years = getYears();
	const months = getMonths();
	defaultValue = defaultValue.split('.');
	const [month, setMonth] = useState(defaultValue.length > 2 ? new Date(+defaultValue[2], defaultValue[1] - 1, +defaultValue[0]).getMonth() : months[0].getMonth());
	const [year, setYear] = useState(defaultValue.length > 2 ? new Date(+defaultValue[2], defaultValue[1] - 1, +defaultValue[0]).getFullYear() : years[0].getFullYear());
	const days = getMonthDates(year, month);
	const [day, setDay] = useState(defaultValue.length > 2 ? new Date(+defaultValue[2], defaultValue[1] - 1, +defaultValue[0]).getDate() : days[0].getDate());
	const dayContainer = useRef(null);

	const translations = useContext(TranslationsContext);

	useEffect(() => {
		const scroll = ScrollHelper.initIScroll(dayContainer.current);

		return () => {
			scroll && scroll.destroy();
		};
	}, []);


	const monthContainer = useRef(null);

	useEffect(() => {
		const scroll = ScrollHelper.initIScroll(monthContainer.current);

		return () => {
			scroll && scroll.destroy();
		};
	}, []);

	const yearContainer = useRef(null);

	useEffect(() => {
		const scroll = ScrollHelper.initIScroll(yearContainer.current);

		return () => {
			scroll && scroll.destroy();
		};
	}, []);

	return <DrawerPopup
		title={getSafeTranslation('BirthdayPopup.title', translations)}
		onOverlayClick={onOverlayClick}
		leftControl={<Button isText onClick={onCancelClick}>
			{getSafeTranslation('BirthdayPopup.cancelButtonCaption', translations)}
		</Button>}
		rightControl={<Button isAutoWidth onClick={() => onDoneClick(`${year}.${month + 1}.${day}`)}>
			{getSafeTranslation('BirthdayPopup.doneButtonCaption', translations)}
		</Button>}
	>
		<div className="birthday">
			<div className="birthday__input">
				<div className="birthday__day-selector" ref={dayContainer}>
					<SelectList>
						{
							days.map(dayDate => {
								const id = dayDate.getDate();
								const isSelected = id === day;

								return (<SelectListItem
									checkboxControl={<Checkbox isChecked={isSelected} isRadio/>}
									key={id}
									name={dayDate.getDate()}
									isSelected={isSelected}
									onClick={() => setDay(id)}
								/>)
							})
						}
					</SelectList>
				</div>
				<div className="birthday__month-selector" ref={monthContainer}>
					<SelectList>
						{
							months.map(monthDate => {
								const id = monthDate.getMonth();
								const isSelected = id === month;

								return (<SelectListItem
									checkboxControl={<Checkbox isChecked={isSelected} isRadio/>}
									key={id}
									name={getSafeTranslation(getMonthTranslationKey(monthDate.getMonth() + 1))}
									isSelected={isSelected}
									onClick={() => setMonth(id)}
								/>);
							})
						}
					</SelectList>
				</div>
				<div className="birthday__year-selector" ref={yearContainer}>
					<SelectList>
						{
							years.map(yearDate => {
								const id = yearDate.getFullYear();
								const isSelected = id === year;
								return (<SelectListItem
									checkboxControl={<Checkbox isChecked={isSelected} isRadio/>}
									key={id}
									name={id}
									isSelected={isSelected}
									onClick={() => setYear(id)}
								/>)
							})
						}
					</SelectList>
				</div>
			</div>
			{
				error && (<div className="birthday__error">
					<Error text={error}/>
				</div>)
			}
		</div>
	</DrawerPopup>
}
